import "./adminBadge.css";

// The one badge implementation. variant is a semantic color role, never a
// raw color - if a new meaning is needed, add a variant here rather than
// hardcoding a color at the call site.
export const AdminBadge = ({ variant = "neutral", children, className = "" }) => (
  <span className={`admin-badge admin-badge--${variant} ${className}`.trim()}>{children}</span>
);
